import {twMerge} from "tailwind-merge";
import {DesktopSize, MobileSize} from "../responsive";

export default function FileInput({
                                      classes = {},
                                      label = "",
                                      placeholder = "",
                                      value = "",
                                      texts = {},
                                      rowLabel = false,
                                      required = false,
                                      onDeleteFile = () => {},
                                      children,
                                      ...otherProps
                                  }) {

    const {
        parentClasses = "",
        bodyClasses = "",
        buttonClasses = "",
        containerClasses = "",
        labelClasses = "",
        inputContainerClasses = "",
        labelContainerClasses = ""
    } = classes;

    const {buttonTitle = "انتخاب فایل"} = texts;

    return (
        <div className={twMerge(`${otherProps.disabled ? "opacity-50 cursor-not-allowed pointer-events-none" : ""} ${rowLabel ? "xl:flex" : ""}`, parentClasses)}>
            {
                label ?
                    <p className={twMerge("ml-7 mt-3 text-sm text-pol-gray whitespace-nowrap", labelClasses)}>
                        {label}
                        {
                            required ? <span className="align-super text-pol-red text-sm">*</span> : null
                        }
                    </p>
                    : null
            }
            <div className={twMerge("w-full", labelContainerClasses)}>
                <label className={twMerge(otherProps.disabled ? "cursor-not-allowed" : "cursor-pointer", inputContainerClasses)}>
                    <input type="file" className="hidden" {...otherProps}/>
                    <div className={twMerge("flex w-full", containerClasses)}>
                        <div
                            className={twMerge(`relative border rounded-r-[0.875rem] flex-grow pr-3.5 pl-6 py-3 text-sm truncate text-pol-dark-2 ${value ? "border-pol-main-dark-color" : "border-pol-light-4"}`, bodyClasses)}>
                            <DesktopSize>
                                <span>{value ? value : placeholder}</span>
                            </DesktopSize>
                            <MobileSize>
                                <span>{typeof value === "string" ? value.slice(0, 15)+"..." : placeholder}</span>
                            </MobileSize>
                            {
                                value ?
                                    <button
                                        type="button"
                                        disabled={otherProps.disabled}
                                        onClick={() => onDeleteFile({target: {name: otherProps.name}})}
                                        className={`text-pol-red absolute left-0.5 w-5 h-5 top-3.5 flex-center z-[5] ${otherProps.disabled ? "cursor-not-allowed" : ""}`}>
                                        <i className="icon-times text-[0.625rem]"/>
                                    </button>
                                    : null
                            }
                        </div>
                        <div
                            className={twMerge(`xl:px-6 px-2.5 py-3 min-w-[7.25rem] xl:min-w-[9.125rem] rounded-l-[0.875rem] font-semibold text-sm flex-center ${value ? "bg-pol-main-dark-color text-pol-dark" : "bg-pol-purple text-white"}`, buttonClasses)}>
                            <i className="icon-upload text-base ml-2"/>
                            <span>{buttonTitle}</span>
                        </div>
                    </div>
                </label>
                <div className="mt-3 pr-1">
                    {children}
                </div>
            </div>
        </div>
    )
}
